'use strict'

// import { set } from 'vue-analytics'
import Cookies from 'utils/Cookies'
import router from '@/router'
// import store from '@/store'
import { apiInstance, loginPath } from './index'
import {
  SESSION_HEADERS,
  SESSION_USER,
  SESSION_COMPANY,
  COST_CENTER_COUNTER
  // SESSION_EXPIRES_TIME
} from 'utils/constants'
import { isNoMainMenuFromV4 } from 'utils/functions'

const user = {
  login (email, password, randId) {
    return apiInstance({
      method: 'POST',
      url: `${loginPath()}/login`,
      data: {
        email,
        password,
        rand_id: randId
      },
      headers: {
        'Content-Type': 'application/json'
      },
      needSign: true
    })
  },

  codeVerify (email, emailCode, ticket) {
    return apiInstance({
      method: 'POST',
      url: `${loginPath()}/verification-code`,
      data: {
        email,
        code: emailCode,
        ticket
      }
    })
  },

  resendCodeVerify (email, ticket) {
    return apiInstance({
      method: 'POST',
      url: `${loginPath()}/verification-code/resend`,
      data: {
        email,
        ticket
      }
    })
  },

  forgotPassword (email) {
    return apiInstance({
      method: 'PUT',
      url: `${loginPath()}/forgotPassword`,
      data: `email=${email}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      needSign: true
    })
  },

  logout () {
    // remove sessions
    Cookies.set(SESSION_USER, '', 0)
    localStorage.removeItem(SESSION_COMPANY)
    localStorage.removeItem(SESSION_HEADERS)

    // localStorage.removeItem(SESSION_EXPIRES_TIME)
    // store.dispatch('sessionExpiresTime/set', null)

    // remove const center count
    localStorage.removeItem(COST_CENTER_COUNTER)

    if (location.hash !== '#/login' && !isNoMainMenuFromV4()) {
      router.push('/login')
    }
  },

  resetPassword (data) {
    return apiInstance({
      method: 'PUT',
      url: `${loginPath()}/changePassword`,
      data
    })
  },
  // TODO 还没有这个接口，先定一个，检查用户是否注册了passport
  checkPassportRegistration (userId) {
    return apiInstance({
      method: 'GET',
      url: `/api/users/${userId}/passport-status`
    })
  }
}

export default user
